import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces } from 'react-i18next';

import { useRouterStore } from 'apps/hooks';

import { Heading, Tooltip } from 'components';
import Banner from 'components/Banner';
import { Divider } from 'apps/components/shared';
import {
  Main as MainForm,
  FormWrapper,
  FieldsWrapper,
  FormField,
  Label,
  InputWrapper,
  Placeholder,
} from 'libs/forms/styles';
import { FullFormField, confToFields } from 'libs/forms/index';
import { BuildForm } from 'apps/build/views/buildForm';
import { LargePanelSectionWrapper } from 'apps/rfq/rfqForm/views/onboarding.styled';

import { InfoIcon } from './jobSpecDetailsForm.styled';

const JobSpecDetailsFormObs = observer(function _jobSpecDetailsForm(props) {
  const { params } = useRouterStore();
  const { jobSpecManager, simpleForm, submitButton, t, addressField } = props;
  const { jobSpecFormStore, manufacturingTimeFieldStore } = jobSpecManager;
  const refs = {};

  const jobSpecFields = confToFields({
    formStore: jobSpecFormStore,
    refs,
    responsive: true,
  });
  const shouldRenderAddress = addressField && !simpleForm;

  return (
    <LargePanelSectionWrapper>
      <Tooltip delayShow={200} place='bottom' id='rfqFormTooltip' />
      {params.get('partId') && (
        <Banner text='We will extract and share only this Part of your Assembly with any match-made Manufacturers.' />
      )}
      <Heading level='2' size='large' margin='0 0 0.75rem 0'>
        {t('Part Details')}
        <InfoIcon
          name='info'
          size='default'
          data-for='rfqFormTooltip'
          data-tip='How would you like this Part to be manufactured?'
        />
      </Heading>
      <BuildForm
        jobSpecManager={jobSpecManager}
        simpleForm={simpleForm}
        refs={refs}
      />
      <Heading level='2' size='large' margin='3rem 0 0.75rem 0'>
        {t('Order Details')}
        <InfoIcon
          name='info'
          size='default'
          data-for='rfqFormTooltip'
          data-tip='How many do you need, how quickly and where do you need them?'
        />
      </Heading>

      <MainForm padding='0' noBorder>
        <FormWrapper posting={jobSpecFormStore.posting} responsive>
          <FieldsWrapper formColumns={2}>
            {jobSpecFields[0]}
            {manufacturingTimeFieldStore ? (
              <FullFormField
                fieldStore={manufacturingTimeFieldStore}
                key={manufacturingTimeFieldStore.fieldName}
                refs={refs}
                responsive={true}
              />
            ) : (
              <FormField formColumns={2}>
                <Label bold>Manufacturing Time</Label>
                <InputWrapper>
                  <Placeholder>Select Process and Material first</Placeholder>
                </InputWrapper>
              </FormField>
            )}
            {shouldRenderAddress && addressField}
          </FieldsWrapper>
        </FormWrapper>
      </MainForm>
      <Divider spacing='default' />
      {submitButton}
    </LargePanelSectionWrapper>
  );
});

export const JobSpecDetailsForm = withNamespaces()(JobSpecDetailsFormObs);

JobSpecDetailsForm.propTypes = {
  rfqManager: PropTypes.object,
};
